export const UiTypes = {
  loadingSet:         "UI/LOADING/SET",

  loaderHide:         "UI/LOADER/HIDE",
  loaderShow:         "UI/LOADER/SHOW",

  menuHide:           "UI/MENU/HIDE",
  menuShow:           "UI/MENU/SHOW",

  mobileSet:          "UI/MOBILE/SET",

  notificationsHide:  "UI/NOTIFICATIONS/HIDE",
  notificationsShow:  "UI/NOTIFICATIONS/SHOW",

  alertPublish:       "UI/ALERT/PUBLISH",
  alertRemove:        "UI/ALERT/REMOVE",
  alertClearAll:      "UI/ALERT/CLEAR_ALL",

  queue:              "UI/QUEUE",
  dequeue:            "UI/QUEUE/DEQUEUE",
  clearQueue:         "UI/QUEUE/CLEAR",

  setFeedbackFormId:  "UI/FEEDBACK_ID/SET",

  recaptchaSet:       "RECAPTCHA_SET",
  recaptchaUnset:     "RECAPTCHA_UNSET",
  recaptchaRequest:   "RECAPTCHA_REQUEST",
  
  beautyProfileToggle: "BEAUTYPROFILE_TOGGLE"
};
